import PropTypes from "prop-types"

export const fieldOptionShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  group: PropTypes.string,
})

export const customFieldShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  fieldUiType: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  helperText: PropTypes.string,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  defaultValueJson: PropTypes.string,
  options: PropTypes.arrayOf(fieldOptionShape),
})

const appletValueShape = PropTypes.any // Object, Array, or String

export const appletFieldShape = PropTypes.shape({
  name: PropTypes.string,
  hidden: PropTypes.bool,
  custom_label: PropTypes.string,
  value: appletValueShape,
})

export const storedFieldShape = PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  owner: PropTypes.string,
  field_subtype: PropTypes.string,
  required: PropTypes.bool,
  resolve_options: PropTypes.string,
  shareable: PropTypes.bool,
  hideable: PropTypes.bool,
  can_have_default: PropTypes.bool,
  helper_text: PropTypes.string,
  default_value: appletValueShape,
  value: appletValueShape,
})

export const stepFieldShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  field_type: PropTypes.string,
  required: PropTypes.bool,
  normalized_field_type: PropTypes.string,
  shareable: PropTypes.bool,
  hideable: PropTypes.bool,
  can_have_default: PropTypes.bool,
  helper_text: PropTypes.string,
  stored_field: storedFieldShape,
})

export const serviceComposerShape = PropTypes.shape({
  id: PropTypes.string,
  module_name: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  lrg_variant_image_url: PropTypes.string,
  lrg_monochrome_image_url: PropTypes.string,
  brand_color: PropTypes.string,
  trigger_count: PropTypes.number,
  query_count: PropTypes.number,
  action_count: PropTypes.number,
  normalized_module_name: PropTypes.string,
  alternate_search_terms: PropTypes.array,
  connect_enabled: PropTypes.boolean,
  incompatible_channels: PropTypes.array,
  public_triggers: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string })
  ),
  public_actions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      incompatible_triggers: PropTypes.array,
    })
  ),
  public_queries: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string })
  ),
})
